import { useRoute } from 'vue-router';

import type { ShallowRef } from 'vue';

const POST_PURCHASE_REFERRERS = ['/purchases/online', '/purchases/tracking', '/purchases/returns', '/my-orders/returns'];

export function usePostPurchaseAnchor(productDetailsRef: ShallowRef<HTMLDivElement | null>) {
  const route = useRoute();

  const isFromPostPurchase = (): boolean => {
    const referrer = document.referrer;
    const cmMmc = route.query.cm_mmc as string | undefined;

    const isOrderPage = POST_PURCHASE_REFERRERS.some((path) => referrer.includes(path));
    const isOES = cmMmc?.startsWith('OpsEmail') ?? false;

    return isOrderPage || isOES;
  };

  onMounted(() => {
    if (isFromPostPurchase()) {
      productDetailsRef.value?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
}
